import React, { useRef, useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/header.css";

const cdnURL = process.env.REACT_APP_CDN_URL;

const Header = ({ isMenuOpen, setIsMenuOpen }) => {

    const mobileWifiUrl = process.env.REACT_APP_MOBILE_WIFI_URL;
    const onlinestoreUrl = process.env.REACT_APP_ONLINESTORE_URL;

    const [hovering, setHovering] = useState(false);
    const closeTimeout = useRef(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    // const [isMenuOpen, setIsMenuOpen] = useState(false); 
    const [openSubMenu, setOpenSubMenu] = useState(null); // track which submenu is open
  
    const aboutUsItems = [
        { url: "/bod", label: "Board of Directors" },
        { url: "/corporate", label: "Corporate Responsibility" },
        { url: "/investorrelations", label: "Investor Relations" },
    ];

    const businessItems = [
        { url: `${mobileWifiUrl}/`, label: "Telecommunications" },
        { url: "https://www.xoxwallet.com/", label: "Fintech" },
        // { url: "/spacedx", label: "Smart Vending Machine" },
    ];

    const navRef = useRef(null);

    // portal state: visible, which menu, measured rects
    const [portal, setPortal] = useState({
        visible: false,
        menuKey: null,      
        navRect: null,      
        offsetLeft: 0,
    });

    // open portal for a menu on mouse enter of the nav-item
    const openMenu = (menuKey, event) => {
        const navEl = navRef.current;
        if (!navEl) return;
        const navRect = navEl.getBoundingClientRect();

        // compute offset: distance from nav left to the link's left
        const linkRect = event.currentTarget.getBoundingClientRect();
        const offsetLeft = Math.max(0, Math.round(linkRect.left - navRect.left));
    
        if (closeTimeout.current) {
            clearTimeout(closeTimeout.current);
        }

        setPortal({
        visible: true,
        menuKey,
        navRect,
        offsetLeft,
        });
    };

    // hide portal (called when leaving nav and portal)
    const closeMenu = () => {
        // delay close so user has time to move cursor down
        if (closeTimeout.current) clearTimeout(closeTimeout.current);

        closeTimeout.current = setTimeout(() => {
            setPortal({ visible: false, menuKey: null, navRect: null, offsetLeft: 0 });
            setHovering(false);
        }, 150); // 150ms grace period
    };

    const toggleSubMenu = (menu) => {
        setOpenSubMenu(openSubMenu === menu ? null : menu);
    };

    // keep measurements updated on resize/scroll
    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);

            if (portal.visible && navRef.current) {
            const navRect = navRef.current.getBoundingClientRect();
            setPortal((p) => ({ ...p, navRect }));
            }
        };

        window.addEventListener("resize", handleResize);
        window.addEventListener("scroll", handleResize, true);

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleResize, true);
        };
    }, [portal.visible]);


    // Portal element
    const portalNode = portal.visible && portal.navRect ? (
        createPortal(
            <div
            className="header-portal-dropdown"
            style={{
                position: "absolute",
                left: `${portal.navRect.left}px`,
                top: `${portal.navRect.bottom}px`,
                width: `${portal.navRect.width}px`,
                zIndex: 100,
            }}
            onMouseEnter={() => {
                // keep menu open while inside
                if (closeTimeout.current) clearTimeout(closeTimeout.current);
                setHovering(true);
            }}
            onMouseLeave={closeMenu} // only close when leaving dropdown itself
            >
            <div className="portal-bar-bg" />
            <div
                className="portal-inner"
                style={{
                position: "absolute",
                left: `${portal.offsetLeft}px`,
                top: 0,
                whiteSpace: "nowrap",
                }}
            >
                <ul className="portal-menu">
                {(portal.menuKey === "about" ? aboutUsItems : businessItems).map(
                    (item, i) => (
                    <li key={i} className="portal-menu-item">
                        <a href={item.url}>{item.label}</a>
                    </li>
                    )
                )}
                </ul>
            </div>
            </div>,
            document.body
        )
    ) : null;

  return (
    <div id="main-wrapper">
        {
            screenWidth > 1100 ?
            <div className='header'>
                <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{ width: "100%" }} ref={navRef} onMouseLeave={closeMenu} >
                    <a className="navbar-brand" href="/">
                        <img src={`${cdnURL}/images/XOX_LOGO_FA-01.png`} alt="XOX Logo" />
                    </a>
                    <div className="collapse navbar-collapse justify-content-center d-none d-lg-flex" id="navbarNav" >
                    <ul className="navbar-nav align-items-center">
                        <li className="nav-item dropdown-parent" onMouseEnter={(e) => openMenu("about", e)} onMouseLeave={closeMenu} >
                            <a className="nav-link" href="/aboutus"> About Us</a>
                        </li>
                        <li className="nav-item dropdown-parent" onMouseEnter={(e) => openMenu("business", e)} onMouseLeave={closeMenu} >
                            <a className="nav-link" href="#"> Our Businesses </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/careers"> Careers </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/contactus"> Contact Us </a>
                        </li>
                    </ul>
                    </div>
                    <div className="d-flex ms-auto" style={ {paddingRight:"90px"}}>
                        <a className="nav-link btn btn-buy me-2" style={{ padding: "5px 20px" }} href={`${mobileWifiUrl}/`}> Buy Online </a>
                        <a className="nav-link btn btn-selfcare" style={{ padding: "5px 20px" }} href={`${onlinestoreUrl}/selfcare/login`}> Self Care </a>
                    </div>
                </nav>
                {portalNode}
            </div>
            : 
            <div className='header' style={{ padding: '0 0 0 5%', justifyContent: 'space-between'}}>
                
                <div className='d-flex' style={{ padding: '2% 5%', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                        <a href="/">
                            <img src={`${cdnURL}/images/XOX_LOGO_FA-01.png`} style={{ width: '10vw',height: 'auto', padding: '0 1%' }} />
                        </a>
                    </div>

                    <div className='clickable' onClick={() => setIsMenuOpen(true)}>
                        <img style={{width:'4vw'}} src={`${cdnURL}/icon/icon_menu.svg`} alt="icon_menu" />
                    </div>
                </div>

                <div className={`sidebar ${isMenuOpen ? 'open' : ''}`}>
                    {/* Close Button */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '1% 10%' }}>
                        <img
                        className="clickable" style={{width:'15px', opacity:'0.3', padding:'10% 0px'}} src={`${cdnURL}/icon/icon_close.svg`} alt="icon_close"
                        onClick={() => setIsMenuOpen(false)}
                        />
                    </div>

                    {/* Menu Items */}
                    <div className="mobile-menu-item">
                        <div className="mobile-item clickable" onClick={() => toggleSubMenu('about')}>
                            <a>About Us</a>
                            <img src={`${cdnURL}/icon/icon_red_arrow.svg`} className={`arrow-menu ${openSubMenu === 'about' ? 'rotated' : ''}`}/>
                        </div>
                        
                        {openSubMenu === 'about' && (
                        <ul className="mobile-submenu">
                            <li><a href="/aboutus">About Us</a></li>
                            <li><a href="/bod">Board of Directors</a></li>
                            <li><a href="/corporate">Corporate Responsibility</a></li>
                            <li><a href="/investorrelations">Investor Relations</a></li>
                        </ul>
                        )}
                    </div>

                    <div className="mobile-menu-item">
                        <div className="mobile-item" onClick={() => toggleSubMenu('business')}>
                            <a>Our Businesses</a>
                            <img src={`${cdnURL}/icon/icon_red_arrow.svg`} className={`arrow-menu ${openSubMenu === 'about' ? 'rotated' : ''}`}/>
                        </div>
                        {openSubMenu === 'business' && (
                        <ul className="mobile-submenu">
                            <li><a href={`${mobileWifiUrl}/`}>Telecommunications</a></li>
                            <li><a href="https://www.xoxwallet.com/">Fintech</a></li>
                            {/* <li><a href="/spacedx">Smart Vending Machine</a></li> */}
                        </ul>
                        )}
                    </div>

                    {/* Regular Links */}
                    <div className="mobile-item">
                        <a href="/careers">Careers</a>
                    </div>
                    <div className="mobile-item">
                        <a href="/contactus">Contact Us</a>
                    </div>
                    <div className="mobile-item2">
                        <a href={`${mobileWifiUrl}/`} className="mobile-btn btn-buy btn">Buy Online</a>
                    </div>
                    <div className="mobile-item2">
                        <a href={`${onlinestoreUrl}/selfcare/login`} className="mobile-btn btn-selfcare btn">Self Care</a>
                    </div>
                </div>
            </div>
        }
    </div>
  );
}
const styles = {

};

export default Header;
